/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as PointsImport } from './routes/_points'
import { Route as IndexImport } from './routes/index'
import { Route as PointsPointsIndexImport } from './routes/_points.points/index'
import { Route as PointsPointsVaultImport } from './routes/_points.points/$vault'

// Create Virtual Routes

const AppLazyImport = createFileRoute('/_app')()
const AppVaultsIndexLazyImport = createFileRoute('/_app/vaults/')()
const AppVaultAddrIndexLazyImport = createFileRoute('/_app/vault/$addr/')()
const AppVaultAddrOpenIndexLazyImport = createFileRoute(
  '/_app/vault/$addr/open/',
)()
const AppVaultAddrCloseIndexLazyImport = createFileRoute(
  '/_app/vault/$addr/close/',
)()
const AppVaultAddrAdjustDebtLazyImport = createFileRoute(
  '/_app/vault/$addr/adjust/debt',
)()
const AppVaultAddrAdjustCollateralLazyImport = createFileRoute(
  '/_app/vault/$addr/adjust/collateral',
)()

// Create/Update Routes

const AppLazyRoute = AppLazyImport.update({
  id: '/_app',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/_app.lazy').then((d) => d.Route))

const PointsRoute = PointsImport.update({
  id: '/_points',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const AppVaultsIndexLazyRoute = AppVaultsIndexLazyImport.update({
  path: '/vaults/',
  getParentRoute: () => AppLazyRoute,
} as any).lazy(() =>
  import('./routes/_app.vaults/index.lazy').then((d) => d.Route),
)

const PointsPointsIndexRoute = PointsPointsIndexImport.update({
  path: '/points/',
  getParentRoute: () => PointsRoute,
} as any)

const PointsPointsVaultRoute = PointsPointsVaultImport.update({
  path: '/points/$vault',
  getParentRoute: () => PointsRoute,
} as any)

const AppVaultAddrIndexLazyRoute = AppVaultAddrIndexLazyImport.update({
  path: '/vault/$addr/',
  getParentRoute: () => AppLazyRoute,
} as any).lazy(() =>
  import('./routes/_app.vault.$addr/index.lazy').then((d) => d.Route),
)

const AppVaultAddrOpenIndexLazyRoute = AppVaultAddrOpenIndexLazyImport.update({
  path: '/vault/$addr/open/',
  getParentRoute: () => AppLazyRoute,
} as any).lazy(() =>
  import('./routes/_app.vault.$addr/open/index.lazy').then((d) => d.Route),
)

const AppVaultAddrCloseIndexLazyRoute = AppVaultAddrCloseIndexLazyImport.update(
  {
    path: '/vault/$addr/close/',
    getParentRoute: () => AppLazyRoute,
  } as any,
).lazy(() =>
  import('./routes/_app.vault.$addr/close/index.lazy').then((d) => d.Route),
)

const AppVaultAddrAdjustDebtLazyRoute = AppVaultAddrAdjustDebtLazyImport.update(
  {
    path: '/vault/$addr/adjust/debt',
    getParentRoute: () => AppLazyRoute,
  } as any,
).lazy(() =>
  import('./routes/_app.vault.$addr/adjust/debt.lazy').then((d) => d.Route),
)

const AppVaultAddrAdjustCollateralLazyRoute =
  AppVaultAddrAdjustCollateralLazyImport.update({
    path: '/vault/$addr/adjust/collateral',
    getParentRoute: () => AppLazyRoute,
  } as any).lazy(() =>
    import('./routes/_app.vault.$addr/adjust/collateral.lazy').then(
      (d) => d.Route,
    ),
  )

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/_points': {
      id: '/_points'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof PointsImport
      parentRoute: typeof rootRoute
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AppLazyImport
      parentRoute: typeof rootRoute
    }
    '/_points/points/$vault': {
      id: '/_points/points/$vault'
      path: '/points/$vault'
      fullPath: '/points/$vault'
      preLoaderRoute: typeof PointsPointsVaultImport
      parentRoute: typeof PointsImport
    }
    '/_points/points/': {
      id: '/_points/points/'
      path: '/points'
      fullPath: '/points'
      preLoaderRoute: typeof PointsPointsIndexImport
      parentRoute: typeof PointsImport
    }
    '/_app/vaults/': {
      id: '/_app/vaults/'
      path: '/vaults'
      fullPath: '/vaults'
      preLoaderRoute: typeof AppVaultsIndexLazyImport
      parentRoute: typeof AppLazyImport
    }
    '/_app/vault/$addr/': {
      id: '/_app/vault/$addr/'
      path: '/vault/$addr'
      fullPath: '/vault/$addr'
      preLoaderRoute: typeof AppVaultAddrIndexLazyImport
      parentRoute: typeof AppLazyImport
    }
    '/_app/vault/$addr/adjust/collateral': {
      id: '/_app/vault/$addr/adjust/collateral'
      path: '/vault/$addr/adjust/collateral'
      fullPath: '/vault/$addr/adjust/collateral'
      preLoaderRoute: typeof AppVaultAddrAdjustCollateralLazyImport
      parentRoute: typeof AppLazyImport
    }
    '/_app/vault/$addr/adjust/debt': {
      id: '/_app/vault/$addr/adjust/debt'
      path: '/vault/$addr/adjust/debt'
      fullPath: '/vault/$addr/adjust/debt'
      preLoaderRoute: typeof AppVaultAddrAdjustDebtLazyImport
      parentRoute: typeof AppLazyImport
    }
    '/_app/vault/$addr/close/': {
      id: '/_app/vault/$addr/close/'
      path: '/vault/$addr/close'
      fullPath: '/vault/$addr/close'
      preLoaderRoute: typeof AppVaultAddrCloseIndexLazyImport
      parentRoute: typeof AppLazyImport
    }
    '/_app/vault/$addr/open/': {
      id: '/_app/vault/$addr/open/'
      path: '/vault/$addr/open'
      fullPath: '/vault/$addr/open'
      preLoaderRoute: typeof AppVaultAddrOpenIndexLazyImport
      parentRoute: typeof AppLazyImport
    }
  }
}

// Create and export the route tree

export const routeTree = rootRoute.addChildren({
  IndexRoute,
  PointsRoute: PointsRoute.addChildren({
    PointsPointsVaultRoute,
    PointsPointsIndexRoute,
  }),
  AppLazyRoute: AppLazyRoute.addChildren({
    AppVaultsIndexLazyRoute,
    AppVaultAddrIndexLazyRoute,
    AppVaultAddrAdjustCollateralLazyRoute,
    AppVaultAddrAdjustDebtLazyRoute,
    AppVaultAddrCloseIndexLazyRoute,
    AppVaultAddrOpenIndexLazyRoute,
  }),
})

/* prettier-ignore-end */

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/_points",
        "/_app"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/_points": {
      "filePath": "_points.tsx",
      "children": [
        "/_points/points/$vault",
        "/_points/points/"
      ]
    },
    "/_app": {
      "filePath": "_app.lazy.tsx",
      "children": [
        "/_app/vaults/",
        "/_app/vault/$addr/",
        "/_app/vault/$addr/adjust/collateral",
        "/_app/vault/$addr/adjust/debt",
        "/_app/vault/$addr/close/",
        "/_app/vault/$addr/open/"
      ]
    },
    "/_points/points/$vault": {
      "filePath": "_points.points/$vault.tsx",
      "parent": "/_points"
    },
    "/_points/points/": {
      "filePath": "_points.points/index.tsx",
      "parent": "/_points"
    },
    "/_app/vaults/": {
      "filePath": "_app.vaults/index.lazy.tsx",
      "parent": "/_app"
    },
    "/_app/vault/$addr/": {
      "filePath": "_app.vault.$addr/index.lazy.tsx",
      "parent": "/_app"
    },
    "/_app/vault/$addr/adjust/collateral": {
      "filePath": "_app.vault.$addr/adjust/collateral.lazy.tsx",
      "parent": "/_app"
    },
    "/_app/vault/$addr/adjust/debt": {
      "filePath": "_app.vault.$addr/adjust/debt.lazy.tsx",
      "parent": "/_app"
    },
    "/_app/vault/$addr/close/": {
      "filePath": "_app.vault.$addr/close/index.lazy.tsx",
      "parent": "/_app"
    },
    "/_app/vault/$addr/open/": {
      "filePath": "_app.vault.$addr/open/index.lazy.tsx",
      "parent": "/_app"
    }
  }
}
ROUTE_MANIFEST_END */
